import * as React from 'react';
import { connect } from 'dva';
import { Menu, Avatar } from 'antd';
import Menuhelper from '../ABSMenu/menuhelper';
import { IUser, ISiteMenu } from '../../../abs/services/auth/authService';
import './index.less';
import ABSIcon from '../../ABSIcon';
import ABSBadge from '../../ABSBadge';

// const MenuItemGroup = Menu.ItemGroup;

interface IProps {
  menu: ISiteMenu;
  user: IUser;
  firstSelectKey: string;
  thirdSelectKey: string;
  dispatch?: any;
}

interface IState {
  activeKey: string;
}

class ABSPerson extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeKey: ''
    };
  }

  handleLogout = e => {
    this.props.dispatch({
      type: 'global/logout'
    });
  };

  // 重置弹出菜单的定位高度
  menuOpenChange(e: string[]) {
    if (e[0] != null) {
      document.getElementById(e[0] + '$Menu')!.style.marginTop = '-7px';
      this.setState({ activeKey: e[0] });
    } else {
      this.setState({ activeKey: '' });
    }
  }

  render() {
    const SubMenu = Menu.SubMenu;
    const { user, menu, firstSelectKey, thirdSelectKey } = this.props;

    let userName = user.name;
    if (userName && userName.length > 3) {
      userName = userName.substring(0, 3) + '...';
    }
    const popoverContent =
      menu && menu.children
        ? menu.children.map((element: ISiteMenu) => {
            const url = element.url ? element.url : '';
            return (
              <Menu.Item key={element.key}>
                <a href={url}>
                  <div className="abs-menu-item">
                    <ABSBadge count={element.isNew ? -1 : 0} isVisibility={true}>
                      {element.name}
                      {!element.isFree ? (
                        element.isOpen ? (
                          <ABSIcon isAnt={true} type="unlock" />
                        ) : (
                          <ABSIcon isAnt={true} type="lock" />
                        )
                      ) : null}
                    </ABSBadge>
                  </div>
                </a>
              </Menu.Item>
            );
          })
        : null;

    return (
      <div className="abs-person">
        <div className="abs-menu">
          <Menu
            selectedKeys={[thirdSelectKey]}
            mode="horizontal"
            onOpenChange={e => this.menuOpenChange(e)}
          >
            <SubMenu
              className="abs-menu-submenu-popup abs-person-popup"
              key={menu ? menu.key : ''}
              title={
                <div className="abs-menu-submenu">
                  <div className="abs-menu-submenu-title">
                    <div className="abs-person-avatar">
                      <Avatar src={user.avatar} />
                    </div>
                    <div className="abs-person-name">{userName}</div>
                    <i className="fc fc-direction-down" />
                    <div
                      className={Menuhelper.getArrowClassName(
                        menu ? menu.key : '',
                        firstSelectKey,
                        this.state.activeKey,
                        thirdSelectKey
                      )}
                    />
                  </div>
                </div>
              }
            >
              {popoverContent}
              <Menu.Item className={'abs-menu-item-danger'}>
                <div className="abs-menu-item" onClick={this.handleLogout}>
                  退出登录
                </div>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return { ...state.account };
}

export default connect(mapStateToProps)(ABSPerson);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSHeader/ABSPerson/index.tsx